/** Public site origin for canonical URLs, sitemap, and JSON-LD. */
export const SITE_ORIGIN = 'https://atithicab.in';

export const routePageUrl = (slug) => `${SITE_ORIGIN}/routes/${slug}`;
